import { action, computed, makeObservable, observable } from 'mobx';

import { Store } from '../../store/store';
import { StoreNode } from '../../store';
import { JobModel } from '../../entities';

export class DocumentPageState extends StoreNode {

  constructor(store: Store) {
    super(store);
    makeObservable(this, {
      jobId: observable,
      isLoading: observable,
      error: observable,
      teamId: observable,
      job: computed,
      mounted: action,
      unmounted: action,
    });
  }

  jobId: string | null = null;
  isLoading = false;
  error: string | null = null;
  teamId: string | null = null;

  get job(): JobModel | null {
    if (!this.jobId)
      return null;
    return this.store.jobManager.maybeGetJob(this.jobId);
  }

  async mounted(jobId: string, teamId?: string) {
    this.jobId = jobId;
    this.teamId = teamId ?? null;
    this.isLoading = true;
    this.error = null;
    this.store.documentUploadGuidedTraining.handleDocumentPageMounted(jobId);

    const [, err] = await this.store.apiFetchJob(jobId);
    if (err) {
      this.error = 'Failed to load job.';
    }

    this.isLoading = false;
  }

  unmounted() {
    this.store.documentUploadGuidedTraining.handleDocumentPageUnmounted();
    this.jobId = null;
    this.isLoading = false;
    this.error = null;
    this.teamId = null;
  }
}
